<template>
  <div>
    <div
      class="input-group color-picker"
      ref="colorpicker"
    >
      <span
        class="colorinput-color"
        :style="'background-color: ' + colorValue"
        @click="togglePicker()"
      />
      <chrome-picker
        :value="colors"
        @input="updateFromPicker"
        v-show="displayPicker"
      />
    </div>
  </div>
</template>

<script>
import { Chrome } from 'vue-color';
import { mapGetters } from 'vuex';
import * as campaignTypes from '@/modules/campaigns/store/types';

export default {
  name: 'BaseColourSelect',
  components: {
    'chrome-picker': Chrome,
  },
  props: {
    value: {
      type: [String, Object],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // selectedColour: '',
      colors: {
        hex: '#000000',
      },
      colorValue: '',
      displayPicker: false,
    };
  },
  computed: {
    ...mapGetters('campaigns', {
      isCampaignReadonly: campaignTypes.GET_IS_CAMPAIGN_READONLY,
    }),
  },
  methods: {
    changeColor(color) {
      this.$emit('input', color);
      this.$emit('change');
    },

    setColor(color) {
      this.updateColors(color);
      this.colorValue = color;
    },
    updateColors(color) {
      this.colorValue = color;
      if (color.slice(0, 1) === '#') {
        this.colors = {
          hex: color,
        };
      }
    },
    showPicker() {
      // this.displayPicker = true;
      document.addEventListener('click', this.documentClick);
      this.displayPicker = true;
    },
    hidePicker() {
      // this.displayPicker = false;
      document.removeEventListener('click', this.documentClick);
      this.displayPicker = false;
    },
    togglePicker() {
      if (!this.isCampaignReadonly) {
        this.displayPicker ? this.hidePicker() : this.showPicker();
      }
    },
    updateFromInput() {
      this.updateColors(this.colorValue);
    },
    updateFromPicker(color) {
      this.colors = color;
      this.colorValue = color.hex;
    },
    documentClick(e) {
      const el = this.$refs.colorpicker;
      if (!el) return;
      const { target } = e;
      if (el !== target && !el.contains(target)) {
        this.hidePicker();
      }
    },
  },
  watch: {
    colorValue(val) {
      if (val) {
        this.updateColors(val);
      }
    },
    displayPicker(val) {
      if (!val) {
        if (this.colorValue !== this.value) { this.changeColor(this.colorValue); }
      }
    },
  },
  created() {
    this.setColor(this.value || '#000000');
  },
};
</script>
<style>
.vc-chrome {
  position: absolute;
  top: 1.85rem;
  right: 0;
  z-index: 99;
}
.current-color {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-color: #000;
  cursor: pointer;
}
.vc-chrome-alpha-wrap{
  display: none;
}
.vc-chrome-hue-wrap{
  margin-bottom: 0;
  margin-top: 8px;
}
.vc-chrome-active-color{
    border: 1px solid #a9a9a9;
}
</style>
